export const RESERVE_DETAIL = {
	singleTypeCd: "",
	goodsCd: "",
	repreNm: "",
	rervNo: "",
	rervSeq: "",
	webCustNo: "",
	rervDt: "",
	evNm: "",
	evCd: "",
	evNightNm: "",
	trTp: "",
	trCompanySnm: "",
	trCompanyNm: "",
	webDisplayCls: "",
	accomNm: "",
	evStartDt: "",
	outDeprtTm: "",
	outArrvTm: "",
	outDayDiff: "",
	outFlightNm: "",
	evArriveDt: "",
	inDeprtTm: "",
	inArrvTm: "",
	inDayDiff: "",
	inFlightNm: "",
	birthDt: "",
	gender: "",
	email: "",
	mobileNo: "",
	telNo: "",
	adtCnt: "",
	chdCnt: "",
	infCnt: "",
	rervNote: "",
	adtPrice: "",
	chdPrice: "",
	infPrice: "",
	bafAdtPrice: "",
	bafChdPrice: "",
	bafInfPrice: "",
	airtaxAdtPrice: "",
	airtaxChdPrice: "",
	airtaxInfPrice: "",
	rervWorkId: "",
	workId: "",
	mgmUserInfo: "",
	mgmUserNm: "",
	mgmDeptNm: "",
	phoneDirect: "",
	emailDirect: "",
	mgmUserTelNo: "",
	mgmUserEmail: "",
	contListSeq: "",
	rervYn: "",
	etaxYn: "",
	cancelDt: "",
	discountPrice: "",
	continentCd: "",
	continentNm: "",
	countryCd: "",
	countryNm: "",
};

export const EVENT_DETAIL = {
	inArrvTm: "",
	inFlightNm: "",
	webDisplayCls: "",
	trCompanySnm: "",
	fakeCnt: "",
	rervCnt: "",
	trTp: "",
	dayCnt: "",
	tourPatInfo: "",
	evStartDt: "",
	trCompanyNm: "",
	outDayDiff: "",
	avlilBlockQty: "",
	inDeprtTm: "",
	evStaCd: "",
	evArriveDt: "",
	outFlightNm: "",
	outDeprtTm: "",
	minCnt: "",
	goodsTp: "",
	inDayDiff: "",
	outArrvTm: "",
	dayStayInfo: "",
	accomNm: "",
	goodsAreaOne: "",
	goodTravelYn: "",
	evCd: "",
	evNm: "",
	goodsBrandCd: "",
	emphasisDivi: "",
	rvwAvgScore: "",
	rvwCnt: "",
	epiCnt: "",
	startCharDivi: "",
	webStartConfYn: "",
	webCancelCommiYn: "",
	webTourDayYn: "",
	webGoodsPriceYn: "",
	webAirConfYn: "",
	webAccommConfYn: "",
	webGuidConfYn: "",
	webInsolConfYn: "",
	shopCnt: "",
	goodsCd: "",
	cancelCnt: "",
	freeScheYn: "",
	expCurrCd: "",
	guideExpAmt: "",
	noTosYn: "",
	stopoverCntYn: "",
	inStovCnt: "",
	outStovCnt: "",
	singleChagYn: "",
	singleChagAmt: "",
	mgmUserInfo: "",
	mgmDeptNm: "",
	mgmUserNm: "",
	mgmUserTelNo: "",
	mgmUserEmail: "",
	phoneDirect: "",
	keypointContList: [],
	evProgDivi: "",
	evProgDiviNm: "",
	insuTargetAttr: "",
	insuTargetExpl: "",
	simpleScheYn: "",
	eventTypeCd: "",
	outUseTmhh: "",
	outUseTmmi: "",
	inUseTmhh: "",
	inUseTmmi: "",
	seatClassCd: "",
	seatClassNm: "",
	greenFeeYn: "",
	caddieFeeYn: "",
	holeCnt: 0,
	continentCd: "",
	continentNm: "",
	countryCd: "",
	countryNm: "",
	fixRervCd: null,
};

export const GOODS_DETAIL = {
	goodsCd: "",
	goodsNm: "",
	tourPatInfo: "",
	minPrice: 0,
	maxPrice: 0,
	minPriceDate: "",
	maxPriceDate: "",
	epiCnt: 0,
	rvwAvgScore: 0,
	rvwCnt: 0,
	goodsTp: "",
	goodsBrandCd: "",
	goodTravelYn: "",
	goodsContents: "",
	webDisplayCls: "",
	goodsTpointContents: null,
	goodsFeaturesList: null,
	goodsTmember: null,
	continentCd: "",
	continentNm: "",
	countryCd: "",
	countryNm: "",
};

export const RESERVE_TOURLIST = {
	tourAgeDivi: "",
	tourListNo: "",
	tourResNmKor: "",
	tourResNmEng: "",
	mobileNo: "",
	birthDt: "",
	gender: "",
	passportAttaFileKey: "",
	tourlistSeq: "",
	ocrCheckYn: "",
	tourSaleAmt: "",
	cancelDt: "",
};

export const EVENT_NOTICE = {
	evCd: "",
	singleTypeCd: "",
	trTp: "",
	goodsCd: "",
	goodsTp: "",
	daySeq: "",
	shopCnt: "",
	inclInfo: "",
	notinclInfo: "",
	miscInfo: "",
	goodsInfo: "",
	vimeoUrl: "",
	shopInfo: "",
	poliInfo: "",
	cancelInfo: "",
	optInfo: "",
	refeInfo: "",
	essenInfo: "",
	passportInfo: "",
	foldAttaFileKey: "",
	stretAttaFileKey: "",
	meetingnoyn: "",
	meetingnm: "",
	meetingtm: "",
	meetingmanager: "",
	meetingtelno: "",
	meetingnote: "",
	keyInfoImageList: [
		{
			evCd: "",
			kinfoDivi: "",
			pcAttaFilePath: "",
			moAttaFilePath: "",
		},
	],
};

export const EVENT_PRICE = {
	adtPrice: 0,
	chdPrice: 0,
	infPrice: 0,
	bafAdtCost: 0,
	bafChdCost: 0,
	bafInfCost: 0,
	airTaxAdtCost: 0,
	airTaxChdCost: 0,
	airTaxInfCost: 0,
	expCurrCd: "",
	guideExpAmt: 0,
	driverAmt: 0,
	depositDivi: "",
	depositDiviNm: "",
	depositAmt: 0,
};

export const GOODS_NOTICE = {
	goodsInfo: "",
	goodsChar: "",
	inclInfo: "",
	notinclInfo: "",
	optInfo: "",
	refeInfo: "",
	essenInfo: "",
	atteInfo: "",
	poliInfo: "",
	passportInfo: "",
	emerInfo: "",
	bankAccInfo: "",
	miscInfo: "",
	shopInfo: "",
	poliTempNm: "",
	cancelInfo: "",
	insuTempNm: "",
	rervInfoImgUrl: "",
	videoUrl: "",
	videoTitle: "",
	videoNote: "",
	videoThum: "",
	vimeoUrl: "",
	foldAttaFileKey: "",
	stretAttaFileKey: "",
	meetingnoyn: "",
	meetingtm: "",
	meetingmanager: "",
	meetingtelno: "",
	meetingnote: "",
	singleTypeCd: "",
	goodsNm: "",
	goodsTpointContents: "",
	keyInfoImageList: [],
	keypointContList: [],
};

// Braze 관련

/**
 * 메뉴 코드별 이름(dspMenuCd)
 */
export const commonMainMenu = {
	EJT: "투어/패스",
	PKG: "해외패키지",
	FIT: "자유여행",
	CRS: "크루즈",
	DMT: "국내여행",
	HYM: "허니문",
	GLF: "골프",
	FBD: "부산|대구출발",
	AIR: "해외항공",
	HTT: "호텔",
	YBP: "TOP PICK",
	BTM: "기업|단체",
	DMA: "국내항공(기획전용)",
	TAT: "땡처리",
	TMA: "테마여행",
	CAR: "렌터카",
};

/**
 * 추천코드별 이름(recCd)
 */
export const commonEventTypeCd = {
	PRC: "출발임박",
	EAB: "얼리버드",
	RCM: "추천상품",
};

/**
 * 테마코드별 이름(themaCd)
 */
export const commonThemaCd = {
	A9: "TOP PICK",
	S3: "아동동반 가족여행",
	A8: "자유허니문",
	G1: "골프텔 (2인 출발 가능)",
	G2: "골프+휴양",
	G3: "골프+관광",
	G4: "장박&전지훈련",
	J4: "어드벤쳐",
};

/**
 * 프로모션코드별 이름(promoCd)
 */
export const commonPromoCd = {
	CHD: "아동할인",
	FID: "선착순 할인",
	FIB: "선착순 혜택",
	SCD: "싱글차지할인",
	TSP: "선발권 특가",
	ERB: "얼리버드",
	SPP: "특가",
	DAN: "땡처리",
	GDH: "황금연휴",
	FDA: "창립기념일",
	FAM: "가정의달",
};

export const commonTpCd = {
	P: "패키지",
	K: "세미패키지",
	F: "자유여행",
	H: "허니문",
	G: "골프",
	C: "크루즈",
	R: "성지순례",
	T: "항공권",
	E: "입장권",
	J: "현지관광",
	L: "호텔",
	S: "테마상품",
	M: "MICE",
};

/**
 * account cookie
 */
export const CookieName = {
	ACCESS: "YB_ACTK",
	REFRESH: "YB_RETK",
} as const;
